const isClientLoggingEnabled =
  process.env.NODE_ENV === 'development' ||
  process.env.REACT_APP_ENABLE_CLIENT_LOGS === 'true';

const write = (level, args) => {
  if (!isClientLoggingEnabled || typeof console === 'undefined') {
    return;
  }

  const log = console[level] || console.log;
  log(...args);
};

const logger = {
  debug: (...args) => write('debug', args),
  info: (...args) => write('info', args),
  warn: (...args) => write('warn', args),
  error: (...args) => write('error', args),
};

export default logger;
